import { appConfig } from '../../config';
import {
  jsonHeaderAuth,
  refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

export const InsertDS = async (req) => {
    const url = `${appConfig.BASE_API}/ds/insert`;
    createAuthRefreshInterceptor(axios, refreshAuthLogic);  
    const result=await axios.post(url,req,jsonHeaderAuth())
    .then(res=>{
      return res.data
      })    
     .catch (error=> {
      return null;
    })
    return result
  };

export const SearchConsumableRequest = async (req) => {
  const url = `${appConfig.BASE_API}/consumable/search`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
    .catch (error=> {
    return null;
  })
  return result
};

export const SearchConsumableRequestGCS = async (req) => {
  const url = `${appConfig.BASE_API}/consumablegcs/search`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
    .catch (error=> {
    return null;
  })
  return result
};

export const InsertDSHistory = async (req) => {
  const url = `${appConfig.BASE_API}/dsh/insert`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};

export const ReadDSHistory = async (req) => {
  const url = `${appConfig.BASE_API}/dsh/range`;
  createAuthRefreshInterceptor(axios, refreshAuthLogic);  
  const result=await axios.post(url,req,jsonHeaderAuth())
  .then(res=>{
    return res.data
    })    
   .catch (error=> {
    return null;
  })
  return result
};